import { api } from "@/lib/axios";

interface buildingCreationProps {
  buildingName: string;
  address: string;
  buildingCity: string;
  buildingState?: string;
  buildingZip: string;
  letterIdBuilding?: string;
  companyId: string;
}

export async function createBuilding({
  buildingName,
  address,
  letterIdBuilding,
  companyId,
  buildingCity,
  buildingState,
  buildingZip,
}: buildingCreationProps) {
  return await api.post(`/buildings/${companyId}`, {
    buildingName,
    address,
    buildingCity,
    buildingState: buildingState || undefined,
    buildingZip,
    letterIdBuilding: letterIdBuilding || undefined,
  });
}
